import React from 'react';
import { motion } from 'framer-motion';
import { FiUsers, FiX } from 'react-icons/fi';
import { SiMinecraft } from 'react-icons/si';
import './Header.css';

/**
 * Header component with logo and navigation
 */
const Header = ({ onCompareToggle, compareMode }) => {
  return (
    <motion.header
      className="header"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 100, damping: 20 }}
    >
      <div className="header-content">
        <a href="/" className="logo">
          <div className="logo-icon">
            <SiMinecraft />
          </div>
          <span className="logo-text">
            <span className="logo-highlight">Hypixel</span>
            <span className="logo-stats">Stats</span>
          </span>
        </a>

        <nav className="nav">
          <motion.button
            className={`nav-button ${compareMode ? 'active' : ''}`}
            onClick={onCompareToggle}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {compareMode ? (
              <>
                <FiX />
                <span>Exit Compare</span>
              </>
            ) : (
              <>
                <FiUsers />
                <span>Compare Players</span>
              </>
            )}
          </motion.button>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;
